module.exports = __webpack_public_path__ + "static/media/ramen-bnb.f4c31c6c.svg";